var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "save") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "topbar",
    transform: "translate(-727.000000, -19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(727.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8,-1.33890236e-05 L4.8,7.2 C4.8,7.6418278 5.1581722,8 5.6,8 L5.6,8 L18.4,8 C18.8418278,8 19.2,7.6418278 19.2,7.2 L19.2,7.2 L19.2,-1.33890236e-05 L21.6,-1.33890236e-05 C21.8126424,-0.00122940704 22.0170249,0.0822507885 22.168,0.232 L22.168,0.232 L28.568,6.632 C28.7177492,6.78297506 28.8012294,6.98735761 28.8000134,7.2 L28.8000134,7.2 L28.8000134,24.8 C28.8000134,27.009139 27.009139,28.8 24.8,28.8 L24.8,28.8 L24,28.8 L24,13.6 C24,13.1581722 23.6418278,12.8 23.2,12.8 L23.2,12.8 L5.6,12.8 C5.1581722,12.8 4.8,13.1581722 4.8,13.6 L4.8,13.6 L4.8,28.8 L4,28.8 C1.790861,28.8 3.62376795e-14,27.009139 3.62376795e-14,24.8 L3.62376795e-14,24.8 L3.62376795e-14,4 C3.62376795e-14,1.790861 1.790861,-1.33890236e-05 4,-1.33890236e-05 L4,-1.33890236e-05 L4.8,-1.33890236e-05 Z M22.4,14.4 L22.4,28.8 L6.4,28.8 L6.4,14.4 L22.4,14.4 Z M18.4,22.4 L10.4,22.4 C9.9581722,22.4 9.6,22.7581722 9.6,23.2 C9.6,23.6418278 9.9581722,24 10.4,24 L10.4,24 L18.4,24 C18.8418278,24 19.2,23.6418278 19.2,23.2 C19.2,22.7581722 18.8418278,22.4 18.4,22.4 L18.4,22.4 Z M18.4,17.6 L10.4,17.6 C9.9581722,17.6 9.6,17.9581722 9.6,18.4 C9.6,18.8418278 9.9581722,19.2 10.4,19.2 L10.4,19.2 L18.4,19.2 C18.8418278,19.2 19.2,18.8418278 19.2,18.4 C19.2,17.9581722 18.8418278,17.6 18.4,17.6 L18.4,17.6 Z M17.6,-2.53515775e-14 L17.6,6.4 L6.4,6.4 L6.4,-2.53515775e-14 L17.6,-2.53515775e-14 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveWhite);
export default __webpack_public_path__ + "static/media/Save_White.ee43a5b5a04ac1c000eb7b1098adac84.svg";
export { ForwardRef as ReactComponent };